// Error boundary for a single R3F subtree. If a child throws (e.g. an
// <Environment> HDRI or skybox fails to load), we hide just that child
// instead of crashing the whole scene/world. Renders null on failure.
import React from 'react';

interface Props { children: React.ReactNode; name?: string }
interface State { failed: boolean }

export class SafeR3F extends React.Component<Props, State> {
  state: State = { failed: false };
  static getDerivedStateFromError(): State { return { failed: true }; }
  componentDidCatch(error: Error) {
    console.warn(`[SafeR3F${this.props.name ? `:${this.props.name}` : ''}] hidden after error:`, error?.message);
  }
  render() {
    return this.state.failed ? null : this.props.children;
  }
}

export default SafeR3F;
